// * Bootstrap libraries
import './_bootstrap';
import './_contact-form';

// * Any other global site-wide JavaScript should be placed below.

